import { ApiError } from '@/services/api'
import { QueryClient } from '@tanstack/react-query'

export const throwOnAuthError = (error: unknown) => {
  if (error instanceof ApiError && [401, 403].includes(error.statusCode)) {
    return true
  }
  return false
}

export const DEFAULT_QUERY_CLIENT_OPTIONS = {
  queries: {
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retryOnMount: false,
  },
  mutations: {
    retry: false,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: DEFAULT_QUERY_CLIENT_OPTIONS,
})
